import PrivacyPolicy from "../../pages/privatePolicyPage"

const ruTransl = {
  translation: {
    header: {
      companyName: 'ФОКС \n ПРИНТ',
      adress: 'г. Владивосток, ул. Снеговая, д.73',
      phoneOne: '8-924-246-45-37',
      phoneTwo: '8-914-707-47-91',
      menuOne: 'О НАС',
      menuTwo: 'УСЛУГИ',
      menuThree: 'ПОРТФОЛИО',
      menuFour: 'КОНТАКТЫ',
    },
    home: {
      quote: 'ЕСЛИ ВАС НЕ ЗАМЕТИЛИ, ВЫ ОСТАНЕТЕСЬ НИ С ЧЕМ. ВАМ НУЖНО, ЧТОБЫ ВАС ЗАМЕТИЛИ.',
      authorName: 'Лео Бернет. ',
      authorWork: 'Основатель одного из крупнейших рекламных агенств в мире Leo Burnett Worldwide',
    },
    services: {
      title: 'Услуги производственной компании \n “ФОКС ПРИНТ”',
      one: 'ШФП, интерьерная печать',
      two: 'Изготовление вывесок',
      three: 'Брендирование автомобилей',
      four: 'Оформление торговых точек',
      five: 'Оформление павильонов',
      six: 'Навигационные стойки',
      seven: 'POS-материалы',
      eight: 'Фрезерная резка',
      nine: 'Лазерная резка',
    },
    aboutUs: {
      title: 'О НАС',
      textParOne: 'Здесь должен быть блок текста, о том, какие мы классные, но его обычно никто не читает. Вместо этого мы разместили несколько интересных цитат про рекламу.',
      textParTwo: '«Единственные настоящие поэты нашего времени служат в рекламных агентствах» Теннесси Уильямс',
      textParThree: '«Творчество без стратегии называется искусством. Творчество со стратегией называется рекламой» Джефф Ричардс',
      textParFour: '«Интерес к жизни во всех ее проявлениях – вот секрет великих творческих людей» Лео Бернетт',
    },
    portfolio: {
      title: 'ПОРТФОЛИО',
    },
    contacts: {
      title: 'КОНТАКТЫ',
      managerOneName: 'Дмитрий',
      managerOneTel: '8-924-246-45-37',
      managerOneEmail: 'Suvenirka2014@inbox.ru',
      managerTwoName: 'Семён',
      managerTwoTel: '8-914-707-47-91',
      managerTwoEmail: '_Semen_@mail.ru',
      adress: 'г. Владивосток, ул. Снеговая, 73',
    },
    footer: {
      year: '© 2026',
      city: 'Владивосток',
      privacyButton: 'Политика конфиденциальности',
    },
    cookie: {
      info: 'Мы используем Яндекс Метрику и cookies для анализа трафика и настройки рекламы. Оставаясь на сайте, вы соглашаетесь с нашей ',
      href: 'Политикой конфиденциальности',
      accept: 'Я согласен',
    },
    privacy: {
      h1: 'Политика в отношении обработки персональных данных',
      h21: '1. Общие положения',
      p11: '1.1. Настоящая Политика обработки персональных данных (далее — Политика) разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет порядок обработки и защиты информации о посетителях сайта "фокспринт.рф"',
      p12: '1.2. Оператором персональных данных является ИП Иванов Дмитрий Андреевич, ИНН 250103129490 (далее — Оператор).',
      p13: '1.3. Использование Сайта, а также нажатие кнопки «Я согласен» на баннере согласия с файлами cookie означает безоговорочное согласие Пользователя с настоящей Политикой.',
      h22: '2. Категории собираемых данных',
      p21: '2.1. Сайт не осуществляет сбор намеренно предоставленных персональных данных (имя, телефон, e-mail), так как не содержит форм обратной связи и регистрации.',
      p22: '2.2. Сайт осуществляет сбор только обезличенных данных о посетителях с помощью сервисов интернет-статистики (Яндекс Метрика) и рекламных инструментов (Яндекс Директ). К таким данным относятся:',
      p221: 'файлы cookie (куки);',
      p222: 'IP-адрес и тип устройства;',
      p223: 'тип браузера и операционной системы;',
      p224: 'дата и время посещения;',
      p225: 'источник перехода на сайт (рекламное объявление, поисковый запрос);',
      p226: 'сведения о действиях на сайте (просмотры страниц, глубина просмотра, отказы).',
      h23: '3. Цели обработки данных',
      p31: '3.1. Сбор и обработка данных производятся в следующих целях:',
      p311: 'анализ посещаемости и качества работы Сайта через сервис Яндекс Метрика;',
      p312: 'оценка эффективности рекламных кампаний в системе Яндекс Директ;',
      p313: 'показ релевантных рекламных объявлений (ретаргетинг) пользователям, ранее посещавшим Сайт;',
      p314: 'улучшение интерфейса и контента лендинга на основе поведенческих факторов.',
      h24: '4. Порядок и условия обработки',
      p41: '4.1. Обработка данных осуществляется автоматизированным способом без доступа сотрудников Оператора к личной личности Пользователя.',
      p42: '4.2. Обработка данных осуществляется с привлечением сервисов ООО «ЯНДЕКС» (ОГРН 1027700229193, РФ, 119021, г. Москва, ул. Льва Толстого, 16), которые обеспечивают хранение данных на серверах в пределах Российской Федерации.',
      p43: '4.3. Оператор принимает необходимые технические меры для защиты собранных данных от несанкционированного доступа.',
      h25: '5. Отказ от обработки данных',
      p51: '5.1. Пользователь может в любой момент отказаться от сбора файлов cookie, изменив настройки своего веб-браузера (запрет на сохранение cookie) или покинув Сайт.',
      p52: '5.2. Также Пользователь может воспользоваться блокировщиком Яндекс Метрики, доступным по адресу: yandex.ru.',
      h26: '6. Сроки обработки',
      p61: '6.1. Срок обработки данных ограничен достижением целей аналитики и маркетинга. Данные в сервисах Яндекса хранятся в соответствии с регламентами ООО «ЯНДЕКС».',
      h27: '7. Контактная информация',
      p7: 'По всем вопросам, связанным с настоящей Политикой, Пользователь может связаться с Оператором по адресу электронной почты: suvenirka2014@inbox.ru.',
      backButton: 'Назад',
    },
  },
}
export default ruTransl